@if (hasErrorsOrWarnings() || isLoading()) {
  <div class="rule-checker p-2"
       [ngClass]="hasOnlyWarnings() ? 'rule-checker-warnings' : 'rule-checker-errors'">
    <div class="error-text-color">
      <div class="text-center">
        @if (isLoading()) {
          <span>
           <span class="spinner-border spinner-border-sm me-1"></span>
           Validating...
         </span>
        } @if (hasErrorsOrWarnings()) {
        <span (click)="toggleErrors()">
           <i class="fa fa-exclamation-triangle me-1"></i>
          @if (showErrors()) {
            <span class="pointer">Hide {{ hasOnlyWarnings() ? 'warnings' : 'errors' }}</span>
          } @if (!showErrors()) {
          <span class="pointer">Show {{ hasOnlyWarnings() ? 'warnings' : 'errors' }}</span>
        }
         </span>
      }
      </div>
    </div>
    @if (showErrors() && hasErrorsOrWarnings()) {
      <ul class="error-messages">
        @for (message of rotaErrors(); track message) {
          <li>{{ message }}</li>
        }
      </ul>
    }
  </div>
}